import { api } from '../../redux/setupAxios';

export async function updateSettings(merchantToUpdate, merchantId) {
	await api.post('merchants/options', { merchantToUpdate, merchantId });
}
